export const getPortalSession = () => {
  const token = localStorage.getItem("staff_portal_token");
  const userType = localStorage.getItem("staff_portal_user_type");
  const user = localStorage.getItem("staff_portal_user");
  const expiresAt = localStorage.getItem("staff_portal_expires_at");

  return {
    token,
    userType,
    user: user ? JSON.parse(user) : null,
    expiresAt,
  };
};

export const clearPortalSession = () => {
  localStorage.removeItem("staff_portal_token");
  localStorage.removeItem("staff_portal_user_type");
  localStorage.removeItem("staff_portal_user");
  localStorage.removeItem("staff_portal_expires_at");
};

export const isPortalSessionExpired = () => {
  const expiresAt = localStorage.getItem("staff_portal_expires_at");
  if (!expiresAt) return true;

  return new Date(expiresAt).getTime() <= Date.now();
};